import { render, staticRenderFns } from "./exam-msg-item.vue?vue&type=template&id=706ae6bd&"
import script from "./exam-msg-item.vue?vue&type=script&lang=js&"
export * from "./exam-msg-item.vue?vue&type=script&lang=js&"
import style0 from "./exam-msg-item.vue?vue&type=style&index=0&id=706ae6bd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports